module.exports = __webpack_public_path__ + "img/delete.bf118e1d.svg";